import React from "react";
import { useTranslation } from "react-i18next";
import "./AmpNewHighlight.css";

interface AmpNewHighlightProps {
    prefaceImage?: string
    size?: "slim" 
}

export default function AmpNewHighlight(props: AmpNewHighlightProps) {
    const { t } = useTranslation("landing");
    return (
        <span className={`new-highlight-top ${props.size}`}>
            {props.prefaceImage && <img className="new-highlight-img" alt="" src={props.prefaceImage}/>}
            <span className="new-text">
                {t("landing.new-text")}
            </span>
        </span>
    )
}